import { Trans } from 'react-i18next';
import { BUSINESS } from '@hotjar/webapp/domains/revenue/plan/feature-group';
import type { PlanDetailsProps } from './components';
import { FeatureList, DefaultFeaturesHeading } from './components';

export function BusinessPlanDetails(props: PlanDetailsProps): JSX.Element {
  return (
    <FeatureList heading={<DefaultFeaturesHeading {...props} plan={BUSINESS} />}>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.all-recording-filters">
        <b>See where users get frustrated.</b> Try out all the Recordings filters, like Rage Clicks.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.user-attributes">
        <b>Advanced segmentation.</b> Your own User IDs, cohorts, and other User Attributes.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.continuous-heatmaps-recordings">
        <b>Continuously building insights.</b> Your user sessions automatically turned into Heatmaps
        & Recordings.
      </Trans>
    </FeatureList>
  );
}
